export default {
  statistics: {
    total_campaigns: 'Kampanjoita yhteensä',
    todays_sent_messages: 'Tänään lähetetyt viestit',
    total_subscribers: 'Tilaajat',
    average_click_rate: 'Keskimääräinen klikkausprosentti',
  },
};
